/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FastEndpointsProblemDetails,
} from '../models/index';
import {
    FastEndpointsProblemDetailsFromJSON,
    FastEndpointsProblemDetailsToJSON,
} from '../models/index';

export interface FxIdWebFeaturesStoreWizQProxyRequestHandlerEndpointRequest {
    game: string;
    jsonData: string;
}

/**
 * 
 */
export class WizqApi extends runtime.BaseAPI {

    /**
     */
    async fxIdWebFeaturesStoreWizQProxyRequestHandlerEndpointRaw(requestParameters: FxIdWebFeaturesStoreWizQProxyRequestHandlerEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError(
                'game',
                'Required parameter "game" was null or undefined when calling fxIdWebFeaturesStoreWizQProxyRequestHandlerEndpoint().'
            );
        }

        if (requestParameters['jsonData'] == null) {
            throw new runtime.RequiredError(
                'jsonData',
                'Required parameter "jsonData" was null or undefined when calling fxIdWebFeaturesStoreWizQProxyRequestHandlerEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['jsonData'] != null) {
            formParams.append('JsonData', requestParameters['jsonData'] as any);
        }

        const response = await this.request({
            path: `/api/v1/wizq/proxyRequestHandler/{Game}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async fxIdWebFeaturesStoreWizQProxyRequestHandlerEndpoint(game: string, jsonData: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.fxIdWebFeaturesStoreWizQProxyRequestHandlerEndpointRaw({ game: game, jsonData: jsonData }, initOverrides);
    }

}
